import { connect } from "react-redux";
import formatMoney from "../helpers/formatMoney";
import { RootState } from "../state/reducers";
import { getTotalPrice } from "../state/reducers/choiceReducer";
import { FormData } from "../types";
import NavButtons from "./NavButtons";

interface FooterProps {
  total: (withDiscount: boolean) => number;
  formData: FormData;
}

const Footer: React.FC<FooterProps> = ({ total, formData }) => {
  const title = "post_title" in formData.post ? formData.post.post_title : "";
  const disclaimer =
    "disclaimers" in formData.post
      ? formData.post.disclaimers.footer_disclaimer
      : "";
  const aaPrice = total(true);
  const msrpPrice = total(false);
  return (
    <footer>
      <h2>{title}</h2>
      <div>
        {aaPrice !== 0 ? (
          <h3>
            {formatMoney(aaPrice)}
            <span>Avid Advantage Price</span>
          </h3>
        ) : null}
        {msrpPrice !== 0 ? (
          <h3 className="total-msrp">
            {formatMoney(msrpPrice)} <span>MSRP</span>
          </h3>
        ) : null}
      </div>
      <p className="disclaimer">{disclaimer}</p>
      <NavButtons pages={formData.entities.pages} />
    </footer>
  );
};

export default connect((state: RootState) => {
  return {
    total: getTotalPrice(state),
    formData: state.formData,
  };
}, {})(Footer);
